export default "__VITE_ASSET__DAP5f2fP__"